import classNames from 'classnames';
import { ReactComponent as IconCloudChecked } from "../../../../assets/svg/icon-cloud-checked.svg";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function TextBar(props) {
  var className = props.className,
    children = props.children;
  return /*#__PURE__*/_jsxs("div", {
    className: classNames('container', className),
    children: [/*#__PURE__*/_jsx(IconCloudChecked, {}), /*#__PURE__*/_jsx("div", {
      className: 'content',
      children: children
    })]
  });
}
export default TextBar;